namespace GeniuzPOS.Inventory {
    export namespace IcStockApproveSetAssembleService {
        export const baseUrl = 'Inventory/IcStockApproveSetAssemble';

        export declare function Create(request: Serenity.SaveRequest<IcStockApproveSetAssembleRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockApproveSetAssembleRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockApproveSetAssembleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockApproveSetAssembleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/IcStockApproveSetAssemble/Create",
            Update = "Inventory/IcStockApproveSetAssemble/Update",
            Delete = "Inventory/IcStockApproveSetAssemble/Delete",
            Retrieve = "Inventory/IcStockApproveSetAssemble/Retrieve",
            List = "Inventory/IcStockApproveSetAssemble/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockApproveSetAssembleService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
